import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI
} from "../utility/config";

function InfoChangedMessage(props) {
    window.setTimeout(function () {
        // Move to a new location
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Asiakkaan tiedot muokattu</h2>
        </div>
    );
}

function ChangeCustomerInfo(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        customerId: props.customerInfo.customerId,
        phoneNumber: '',
        bonus: ''
    })
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    // onChange functions
    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    // Submit
    const doSubmit = async (e, index) => {
        e.preventDefault()
        console.log(userData)
        let newCustomerInfo = userData
        const dataToServer = {
            ...userData,
            bonus: Number(userData.bonus)
        }
        if (userData.phoneNumber === '' && userData.bonus === '') {
            setShow(!show);
        } else if (userData.phoneNumber !== '' && userData.bonus === '') {
            try {
                await axios.post(`${SERVER_URI}/change_customer_phone_number/`, userData, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "UPDATE_CUSTOMER_PHONENUMBER", data: { newCustomerInfo: newCustomerInfo } })
                setShow(!show);
            } catch (e) {
                console.log("Error in updating info", e)
            }
        } else if (userData.phoneNumber === '' && userData.bonus !== '') {
            try {
                await axios.post(`${SERVER_URI}/set_customer_bonus/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "UPDATE_CUSTOMER_BONUS", data: { newCustomerInfo: newCustomerInfo } })
                setShow(!show);
            } catch (e) {
                console.log("Error in updating info", e)
            }
        } else {
            try {
                await axios.post(`${SERVER_URI}/set_customer_bonus/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                await axios.post(`${SERVER_URI}/change_customer_phone_number/`, userData, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "UPDATE_CUSTOMER_PHONENUMBER", data: { newCustomerInfo: newCustomerInfo } })
                props.dispatch({ type: "UPDATE_CUSTOMER_BONUS", data: { newCustomerInfo: newCustomerInfo } })
                setShow(!show);
            } catch (e) {
                console.log("Error in updating info", e)
            }
        }

    }

    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Muokkaa asiakkaan tietoja</h2>
                            <form className="changeInfo_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="customerCallSign">Asiakkaan nimimerkki:</label>{props.customerInfo.callSign}<br />
                                <label className="label_add" htmlFor="customerId">Asiakkaan Id:</label>{props.customerInfo.customerId}<br />
                                <label className="label_add" htmlFor="customerOldPhonenumber">Asiakkaan vanha puhelinnumero:</label>{props.customerInfo.phoneNumber}<br />
                                <label className="label_add" htmlFor="customerOldPhonenumber">Asiakkaan Bonus:</label>{props.customerInfo.accumulatedBonus} €<br />
                                <label className="label_add" htmlFor="customerNewPhonenumber">Asiakkaan uusi puhelinnumero:</label>
                                <input type="text" id="phoneNumber" name="phoneNumber" onChange={onChange} placeholder="Puhelinnumero" ></input><br className="desktop-break" />
                                <label className="label_add" htmlFor="customerNewBonus">Asiakkaan bonuksen määrä:</label>
                                <input type="text" id="bonus" name="bonus" onChange={onChange} placeholder="Uusi Bonus" ></input>€<br className="desktop-break" />

                                <input type="submit" id="gradient_Button" value="Muokkaa tiedot" />
                            </form>
                        </div>
                    )}
                    {show && <InfoChangedMessage handleClose={props.handleClose} />}
                </div>
            </div>

        </div>

    );
}

export default ChangeCustomerInfo;